export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_06.01dfd387.jpg";